import { pino } from 'pino';

import { env } from './env';

const isProduction = env.prod || env.mode === 'production';
const level = isProduction ? 'silent' : env.logLevel || 'info';

const COLOR = {
  GREEN: `\x1b[32m`,
  RED: `\x1b[31m`,
  WHITE: `\x1b[37m`,
  YELLOW: `\x1b[33m`,
  CYAN: `\x1b[36m`,
};

const LEVEL_COLORS = {
  FATAL: COLOR.RED,
  ERROR: COLOR.RED,
  WARN: COLOR.YELLOW,
  INFO: COLOR.GREEN,
  DEBUG: COLOR.GREEN,
  TRACE: COLOR.GREEN,
};

function formatTimestamp(time: unknown): string {
  if (time == null) return '';
  try {
    const d = new Date(String(time));
    return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(11, 23);
  } catch {
    return '';
  }
}

function safeString(value: unknown): string {
  try {
    return value == null ? '' : String(value);
  } catch {
    return '[?]';
  }
}

const logger = pino({
  level,
  browser: {
    write(logObj: unknown) {
      try {
        if (logObj == null || typeof logObj !== 'object') {
          console.log('[logger]', logObj);
          return;
        }
        const obj = logObj as Record<string, unknown>;
        const levelVal = obj.level;
        const msg = obj.msg;
        const context = obj.context;
        const time = obj.time;
        const logParams = { ...obj };
        delete logParams.level;
        delete logParams.msg;
        delete logParams.context;
        delete logParams.time;

        const label = safeString(levelVal).toUpperCase() || 'INFO';
        const labelColor = LEVEL_COLORS[label] ?? '';
        const reset = '\x1b[0m';
        const ts = formatTimestamp(time);
        const contextPart = context ? `${COLOR.CYAN}${safeString(context)} ${reset}` : '';

        console.log(
          `${ts} ${labelColor}${label} ${contextPart}${safeString(msg)}`,
          ...Object.values(logParams),
        );
      } catch (err) {
        console.error(
          '[logger] write failed:',
          err instanceof Error ? err.message : String(err),
          logObj,
        );
      }
    },
    formatters: {
      level: (label) => ({ level: label }),
    },
  },
  base: {
    service: 'turfmaster-client',
    environment: env.mode || (env.prod ? 'production' : 'development'),
  },
});

export const apiLogger = logger.child({ context: 'api' });
export const gameLogger = logger.child({ context: 'game' });
export const uiLogger = logger.child({ context: 'ui' });

export default logger;
